import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const TableDotsIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 16 16" sx={{ height: '16px', width: '16px', fill: 'transparent', ...sx }} {...props}>
      <path
        d="M8.00004 8.6665C8.36823 8.6665 8.66671 8.36803 8.66671 7.99984C8.66671 7.63165 8.36823 7.33317 8.00004 7.33317C7.63185 7.33317 7.33337 7.63165 7.33337 7.99984C7.33337 8.36803 7.63185 8.6665 8.00004 8.6665Z"
        fill="#14191F"
      />
      <path
        d="M8.00004 3.99984C8.36823 3.99984 8.66671 3.70136 8.66671 3.33317C8.66671 2.96498 8.36823 2.6665 8.00004 2.6665C7.63185 2.6665 7.33337 2.96498 7.33337 3.33317C7.33337 3.70136 7.63185 3.99984 8.00004 3.99984Z"
        fill="#14191F"
      />
      <path
        d="M8.00004 13.3332C8.36823 13.3332 8.66671 13.0347 8.66671 12.6665C8.66671 12.2983 8.36823 11.9998 8.00004 11.9998C7.63185 11.9998 7.33337 12.2983 7.33337 12.6665C7.33337 13.0347 7.63185 13.3332 8.00004 13.3332Z"
        fill="#14191F"
      />
      <path
        d="M8.00004 8.6665C8.36823 8.6665 8.66671 8.36803 8.66671 7.99984C8.66671 7.63165 8.36823 7.33317 8.00004 7.33317C7.63185 7.33317 7.33337 7.63165 7.33337 7.99984C7.33337 8.36803 7.63185 8.6665 8.00004 8.6665Z"
        stroke="#14191F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00004 3.99984C8.36823 3.99984 8.66671 3.70136 8.66671 3.33317C8.66671 2.96498 8.36823 2.6665 8.00004 2.6665C7.63185 2.6665 7.33337 2.96498 7.33337 3.33317C7.33337 3.70136 7.63185 3.99984 8.00004 3.99984Z"
        stroke="#14191F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00004 13.3332C8.36823 13.3332 8.66671 13.0347 8.66671 12.6665C8.66671 12.2983 8.36823 11.9998 8.00004 11.9998C7.63185 11.9998 7.33337 12.2983 7.33337 12.6665C7.33337 13.0347 7.63185 13.3332 8.00004 13.3332Z"
        stroke="#14191F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default TableDotsIcon;
